import dJSON from 'dirty-json';

(() => {
  const moduleSelector = '.about-us';

  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove();
      const { data } = dJSON.parse(query.data);
      const usps = query.querySelector('.js-about-us-usps');

      data.forEach((item) => {
        usps.insertAdjacentHTML('beforeend', /* html */ `
          <div class="about-us__usp">
            <img class="about-us__usp-icon" src="${item.icon}" alt="">
            <span class="about-us__usp-divider" aria-hidden="true"></span>
            <div class="about-us__usp-text">
              <p class="about-us__usp-title">${item.title}</p>
              <p class="about-us__usp-desc">${item.text}</p>
            </div>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
